import { ensureSegmentScriptCrossOrigin } from "@/domains/metrics/segment-utils";
import { clientEnvModule } from "@/modules/client-env";
import { AnalyticsBrowser } from "@segment/analytics-next";

ensureSegmentScriptCrossOrigin();

export const segmentAnalyticsInstance = (() => {
  let instance: AnalyticsBrowser;

  return () => {
    if (instance) return instance;

    const writeKey = clientEnvModule.isDesktop()
      ? import.meta.env.VITE_DESKTOP_SEGMENT_WRITE_KEY
      : import.meta.env.VITE_SEGMENT_WRITE_KEY;

    instance = AnalyticsBrowser.load({
      writeKey,
    });

    return instance;
  };
})();
